import { navigationGuard } from '../../lib/vue/navigationGuard'

function ensureShoppingCartExists (store) {
  return async (to, from, next) => {
    const { shoppingCartID } = to.params
    await store.dispatch('site/load')
    await store.dispatch('shoppingCart/fetch', shoppingCartID)
    await store.dispatch('shoppingCart/watch')
    next()
  }
}

export default ({ store }) => {
  return navigationGuard(ensureShoppingCartExists(store))
}
